import script from "./ManageFactor.vue?vue&type=script&setup=true&lang=js"
export * from "./ManageFactor.vue?vue&type=script&setup=true&lang=js"

import "./ManageFactor.vue?vue&type=style&index=0&id=e4ab5d06&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e4ab5d06"]])

export default __exports__